import React, { createContext, useState } from "react";
import usePersistedState from "../hooks/usePersistedState";
export const FormContext = createContext({
  name: "",
  email: "",
  message: "",
});

const FormProvider = ({ children }) => {
  const [formInfo, setFormInfo] = usePersistedState(
    {
      name: "",
      email: "",
      message: "",
    },
    "formInfo"
  );
  return (
    <FormContext.Provider value={{ formInfo, setFormInfo }}>
      {children}
    </FormContext.Provider>
  );
};

export default FormProvider;
